import { Avatar, Box, Button, CircularProgress } from "@mui/material";
import React, { useState } from "react";
import { allIcons } from "../../assets";
import { helper } from "../../helper/uploader";

function ImageUploader({ image, onUploadSuccess, handleSnackbarVal }) {
  const [isLoading, setIsLoading] = useState(false);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setIsLoading(true);

    try {
      const uploadedUrl = await helper.uploadMediaService(file);
      onUploadSuccess(uploadedUrl);
      handleSnackbarVal(true, "success", "Image uploaded successfully");
    } catch (error) {
      console.error(error);
      handleSnackbarVal(true, "error", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box position={"relative"} display={"inline-block"}>
      <Avatar src={image} sx={{ height: 100, width: 100 }} />
      <Button
        disableRipple
        sx={{
          width: "auto",
          height: 0,
          padding: 0,
          position: "absolute",
          right: "-45px",
          bottom: 6,
          fontSize: "0.75rem",
          "&:hover": {
            background: "transparent",
          },
        }}
        endIcon={
          <img
            src={allIcons.editFillIcon}
            alt={"edit-icon"}
            width={16}
            height={17}
          />
        }
        variant="none"
        component="label"
      >
        {isLoading ? <CircularProgress size={16} /> : "Change"}
        <input
          type="file"
          accept="image/*"
          hidden
          onChange={handleFileChange}
        />
      </Button>
    </Box>
  );
}

export default ImageUploader;
